//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { StringService } from "@nuskin/ns-util";

export default {
  name: "NsTopnavNavigation",
  props: {
    navigation: {
      type: [Array, String],
      default: function() {
        return [];
      }
    },
    navType: {
      type: String,
      default: ""
    },
    hideSeeAll: Boolean
  },
  data() {
    return {
      localTranslations: {
        allCategoryText: "See all %categoryName%"
      }
    };
  },
  computed: {
    localNavigation() {
      return Array.isArray(this.navigation)
        ? this.navigation
        : JSON.parse(this.navigation);
    },
    listStyle() {
      if (this.navType === "storefront") {
        return {
          maxWidth: this.localNavigation.length < 10 ? "750px" : "1000px",
          columns: this.localNavigation.length < 10 ? 3 : 4
        };
      }
      return {};
    }
  },
  mounted() {
    this.setCommonStrings();
  },
  methods: {
    getAllCategoryText(category) {
      const allCategoryText = this.localTranslations.allCategoryText;
      return allCategoryText.replace(
        "%categoryName%",
        category.title || category.name
      );
    },
    setCommonStrings() {
      const commonStrings = [
        { key: "allCategoryText", dflt: "See all %categoryName%" }
      ];
      StringService.getStrings(commonStrings).then(data => {
        this.localTranslations = { ...this.localTranslations, ...data };
      });
    }
  }
};
